var r = /* @__PURE__ */ ((p) => (p.link = "link", p.optin = "optin", p.header = "header", p.product = "product", p))(r || {});
export {
  r as StoreItemEnum
};
